export default __webpack_public_path__ + "static/media/geo-map-image.53eefd20.PNG";